module.exports = __webpack_public_path__ + "img/lawnstarter.3081e31a.svg";